import { Deserializable } from '../protocols/deserializable';
import { BaseType } from '../base/base-type';
import { VariableBenefitPaymentFrequencyEnum } from '../enum/shared/variable-benefit-payment-frequency.enum';

export class RecurringPaymentInstruction implements Deserializable {
  public paymentFrequencyId!: VariableBenefitPaymentFrequencyEnum;
  public paymentStartDate!: string;
  public useMinimumAmount!: boolean;
  public paymentAmount!: number;
  public paymentFrequency!: BaseType;
  public endDate!: string;

  public onDeserialize(): void {}
}
